import axios from "axios";
import { endpointApi } from "../../utils";
import { logout } from "./auth.action";
import { TASK_BAMBOU_LIST_FAIL, TASK_BAMBOU_LIST_REQUEST, TASK_BAMBOU_LIST_SUCCESS, TASK_RAMBO_LIST_FAIL, TASK_RAMBO_LIST_REQUEST, TASK_RAMBO_LIST_SUCCESS } from "../constats/task.constant";

export const getTaskRambos = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: TASK_RAMBO_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }task-rambos${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: TASK_RAMBO_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: TASK_RAMBO_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: TASK_RAMBO_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}

export const getTaskBambous = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: TASK_BAMBOU_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }task-bambous${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: TASK_BAMBOU_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: TASK_BAMBOU_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: TASK_BAMBOU_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}